import { Link, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BrandLogo } from './BrandLogo';
import { CookieConsent } from './CookieConsent';
import { LanguageSwitcher } from './LanguageSwitcher';
import { CONTACT } from '../config';

export function Layout() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <div className="layout">
      <header className="nav">
        <div className="nav-inner">
          <Link to="/" className="nav-brand-link" aria-label="Shmatch — Home">
            <BrandLogo variant="wordmark" className="nav-logo-img" alt="" />
          </Link>
          <nav className="nav-links" aria-label="Main">
            <Link to="/vendors">{t('nav.forVendors')}</Link>
            <LanguageSwitcher />
          </nav>
        </div>
      </header>
      <main className="layout-main">
        <Outlet />
      </main>
      <footer className="footer footer--extended">
        <div className="footer-inner">
          <Link to="/" className="footer-brand-link" aria-label="Shmatch">
            <BrandLogo variant="wordmark" className="footer-logo-img" alt="" />
          </Link>
          <div className="footer-legal">
            <p>
              <strong>{t('footer.legalHeading')}</strong>
            </p>
            <p>{t('footer.companyLine')}</p>
            <p>{t('footer.vat')}</p>
            <p>{t('footer.gemi')}</p>
            <p>{t('footer.address')}</p>
            <nav className="footer-nav" aria-label="Footer">
              <Link to="/about">{t('nav.about')}</Link>
              <Link to="/payments">{t('nav.payments')}</Link>
              <Link to="/legal">{t('nav.legal')}</Link>
              <Link to="/vendors">{t('nav.forVendors')}</Link>
            </nav>
            <p className="footer-meta">
              <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
              {' · '}
              <a href={`tel:${CONTACT.phoneTel}`}>{CONTACT.phoneDisplay}</a>
            </p>
          </div>
          <p className="footer-copy">
            &copy; {year} {t('footer.copyright')}
          </p>
        </div>
      </footer>
      <CookieConsent />
    </div>
  );
}
